import { render, staticRenderFns } from "./user-info-uploader.vue?vue&type=template&id=39914b80&scoped=true"
import script from "./user-info-uploader.vue?vue&type=script&lang=js"
export * from "./user-info-uploader.vue?vue&type=script&lang=js"
import style0 from "./user-info-uploader.vue?vue&type=style&index=0&id=39914b80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39914b80",
  null
  
)

export default component.exports